export enum AccountQueryKeys {
  ListUsers = 'account/listUsers',
  ListGroups = 'account/listGroups',
  ListAttributes = 'account/listAttributes',
  AppGetIdentities = 'account/appGetIdentities',
}
